export default __webpack_public_path__ + "static/default-dog-43108bff1ef8237806d7227e11ee225c.jpg";